import React from "react";
import { useNavigate } from "react-router-dom";
import { ProjectData } from "../../../MockData";

const Products = () => {
  const navigate = useNavigate();

  const handleInquiryClick = (project) => {
    navigate(`/product/${project.id}`, { state: { product: project } });
  };

  return (
    <div className="relative flax py-16">
      {/* Background Layer with Opacity */}
      <div
        className="absolute inset-0 z-0 opacity-20 bg-repeat"
        style={{
          backgroundImage: `url(/assets/blueline.webp)`,
          backgroundSize: "auto",
        }}
      />

      {/* Foreground Content */}
      <div className="relative section-container flax-col gap-5 text-center z-10">
        <div className="title-space">
          <div className="section-title">Featured Project</div>
          <h2 className="title-description">
            The creativeness that your product <br /> wants the most.
          </h2>
        </div>

        <div className="grid gap-6 grid-cols-1 md:grid-cols-4">
          {ProjectData.map((project, idx) => (
            <div
              key={idx}
              className="bg-blue_bg-100 rounded-md shadow-md overflow-hidden"
            >
              <div className="w-full flex justify-center items-center p-4  h-60">
                <img
                  src={`/assets/${project.image}`}
                  alt={project.title}
                  className="w-48 h-48 object-contain"
                />
              </div>

              <div className="p-6 space-y-4">
                {/* <p className="text-sm text-text_color-100">
                  Home / Products /{" "}
                  <span className="text-black font-medium">
                    {project.category}
                  </span>
                </p> */}
                <h3 className="text-xl font-semibold text-text_color-200">
                  {project.category}
                </h3>
                <p className="text-sm text-text_color-100">
  {project.description.length > 30
    ? project.description.slice(0, 90) + "..."
    : project.description}
</p>

                <button
                  onClick={() => handleInquiryClick(project)}
                  className="w-full bg-primary-200 shadow-sharp-blue text-white py-2 hover:bg-blue-800 transition"
                >
                  View Detail
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Products;
